import "../../../chunks/server.js";
import "../../../chunks/client.js";
import "../../../chunks/navigation.js";
//#region src/routes/login/+page.svelte
function _page($$renderer, $$props) {
	$$renderer.component(($$renderer) => {
		$$renderer.push(`<div class="flex flex-wrap lg:flex-nowrap bg-[url('/images/lakeside.jpg')] bg-no-repeat bg-center bg-cover"><div class="flex justify-center items-center h-[calc(100vh-64px)] lg:h-svh w-full p-4"><form action="?/login" method="post"><div class="flex flex-col items-center gap-4 w-full sm:w-[380px] rounded-md bg-zinc-100 p-4 min-h-32"><h1>Welcome!</h1> <input type="email" name="email" placeholder="Email" class="border border-zinc-400 rounded-md h-9 p-2"/> <input type="password" name="password" placeholder="Password" class="border border-zinc-400 rounded-md h-9 p-2"/> <button type="submit" class="px-4 h-9 rounded-md bg-slate-500 text-white hover:brightness-90">Log In</button></div></form></div></div>`);
	});
}
//#endregion
export { _page as default };
